import { COMPANY_SIGNUP_URL } from 'consts';
import { useCallback } from 'react';

export const useHandleCompanySignup = () => {
  // Uncomment to scroll to pricing section when signup button is clicked
  // const handleCompanySignup = useCallback(() => {
  //   document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
  // }, []);

  const handleCompanySignup = useCallback(() => {
    window.location.assign(`${COMPANY_SIGNUP_URL}/plan-calculator`);
  }, []);

  return handleCompanySignup;
};
